<template>
  <div class="common-dialogue">
    <qc-dialog
      :title="title"
      type="custom"
      :show.sync="isShow"
      :default-cancel="false"
      :no-close-button="noCloseButton"
      :width="width"
      @close="onCancel"
    >
      <!--eslint-disable-next-line vue/no-v-html -->
      <span v-html="text" />
      <div slot="button">
        <qc-button
          v-show="!noCancelBtn"
          :style="cancelBtnStyle"
          type="weak"
          @click="onCancel"
        >
          {{ cancelBtnText }}
        </qc-button>
        <qc-button
          v-show="!noConfirmBtn"
          :style="confirmBtnStyle"
          :title="confirmBtnText"
          @click="onConfirm"
        >
          {{ confirmBtnText }}
        </qc-button>
      </div>
    </qc-dialog>
  </div>
</template>


<script>
export default {
  name: 'CommonDialogue',
  props: {
    title: {
      default: '',
      type: String,
    },
    text: {
      default: '',
      type: String,
    },
    noCloseButton: {
      default: false,
      type: Boolean,
    },
    noCancelBtn: {
      default: false,
      type: Boolean,
    },
    noConfirmBtn: {
      default: false,
      type: Boolean,
    },
    cancelBtnText: {
      default: '取消',
      type: String,
    },
    confirmBtnText: {
      default: '确定',
      type: String,
    },
    width: {
      default: 450,
      type: Number,
    },
    confirmBtnType: {
      default: '',
      type: String,
    },
  },
  data() {
    return {
      isShow: false,
    };
  },
  computed: {
    cancelBtnStyle() {
      return {
        marginRight: '10px',
      };
    },
    dialogStyle() {
      return {
        width: '100px',
      };
    },
    confirmBtnStyle() {
      return this.confirmBtnType === 'danger'
        ? { backgroundColor: 'red', border: 'none' }
        : {};
    },
  },
  methods: {
    showConfirm() {
      this.isShow = true;
    },
    onConfirm() {
      this.$emit('confirm');
      this.isShow = true;
    },
    onCancel() {
      this.$emit('cancel');
      this.isShow = false;
    },
  },
};
</script>

<style lang="less">
.common-dialogue {
  position: relative;
  z-index: 3;
}
</style>
